export enum Language {
  Sv = 'sv',
  Da = 'da',
  No = 'no',
  Fr = 'fr',
  En = 'en',
  Es = 'es',
}
